// 默认布局使用的多语言

export default {
    'zh-CN': {
        basicLayout: {
            search: {
                placeholder: '搜索...',
                cancel: '取消'
            },
            user: {
                center: '个人信息',
                setting: '修改密码',
                logOut: '退出登录',
                changeOrg:'切换当前组织'
            },
            logout: {
                confirmTitle: '退出登录确认',
                confirmContent: '您确定退出系统吗？'
            },
            tabs: {
                left: '关闭左侧',
                right: '关闭右侧',
                other: '关闭其它',
                all: '全部关闭'
            }
        }
    },
    'en-US': {
        basicLayout: {
            search: {
                placeholder: 'Search...',
                cancel: 'Cancel'
            },
            user: {
                center: 'My home',
                setting: 'Setting',
                logOut: 'Log out',
                changeOrg:'Toggle current Org' 
            },
            logout: {
                confirmTitle: 'Logout confirmation',
                confirmContent: 'Are you sure you are logged out of your current account? '
            },
            tabs: {
                left: 'Close left',
                right: 'Close right',
                other: 'Close other',
                all: 'Close all'
            }
        }
    },
    'ja-JP': {
        basicLayout: {
            search: {
                placeholder: '検索する...',
                cancel: 'キャンセルする'
            },
            user: {
                center: '個人情報',
                setting: 'パスワードを変更する',
                logOut: 'ログアウトする',
                changeOrg:'現在の組織を切り替える' 
            },
            logout: {
                confirmTitle: 'ログアウト確認',
                confirmContent: '現在のアカウントからログアウトしてもよろしいですか？'
            },
            tabs: {
                left:  '左を閉じる',
                right: '右を閉じる',
                other: '他を閉じる',
                all: 'すべて閉じる'
            }
        }
    }
}
